import { FilterCriteria, FilterOperation } from '@ird/shared-base';

export type FilterFieldType = 'string' | 'number' | 'boolean' | 'date' | 'enum' | 'json';

export const DEFAULT_OPERATIONS: Record<FilterFieldType, FilterOperation[]> = {
  string: [FilterOperation.LIKE, FilterOperation.EQUALS],
  number: [FilterOperation.EQUALS, FilterOperation.GREATER_THAN, FilterOperation.LESS_THAN],
  boolean: [FilterOperation.EQUALS],
  date: [FilterOperation.EQUALS, FilterOperation.GREATER_THAN, FilterOperation.LESS_THAN],
  enum: [FilterOperation.EQUALS],
  json: [FilterOperation.JSON_CONTAINS],
};

export interface FilterFieldDefinition {
  field: string;
  label: string;
  type: FilterFieldType;
  operations?: FilterOperation[];
  values?: FilterFieldValue[];
  /** json fields only: the keys offered before the user types the value. */
  jsonKeys?: FilterFieldValue[];
}

export interface FilterFieldValue {
  value: string;
  label: string;
  /** json keys only: the values offered once this key is picked. Empty means free text. */
  values?: FilterFieldValue[];
}

export interface ActiveFilter {
  field: FilterFieldDefinition;
  operation: FilterOperation;
  value?: string;
  values?: string[];
  displayValue: string;
}

export interface FilterSearchParameters<T = Record<string, unknown>> {
  search: string;
  filters: FilterCriteria<T>[];
}

export enum FilterPhase {
  FIELD = 'field',
  OPERATOR = 'operator',
  VALUE = 'value',
}

export const OPERATOR_LABELS: Record<FilterOperation, string> = {
  [FilterOperation.EQUALS]: '=',
  [FilterOperation.NOT_EQUALS]: '!=',
  [FilterOperation.LIKE]: '~',
  [FilterOperation.IN]: 'in',
  [FilterOperation.IS_NULL]: 'is empty',
  [FilterOperation.IS_NOT_NULL]: 'is not empty',
  [FilterOperation.GREATER_THAN]: '>',
  [FilterOperation.LESS_THAN]: '<',
  [FilterOperation.GREATER_THAN_OR_EQUAL]: '>=',
  [FilterOperation.LESS_THAN_OR_EQUAL]: '<=',
  [FilterOperation.JSON_CONTAINS]: 'contains',
};
